import { createApi } from '@reduxjs/toolkit/query/react';

import { setWebcastLoginData } from './webCastLoginSlice';
import createBaseQuery from '../../utils/baseQuery';

const baseQueryWithReAuth = createBaseQuery('user');

export const webCastApiSlice = createApi({
  reducerPath: 'webCastApi',
  baseQuery: baseQueryWithReAuth,
  endpoints: (builder) => ({
    webcastLogIn: builder.mutation({
      query: (credentials) => ({
        url: '/webcast-login',
        method: 'POST',
        body: credentials
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setWebcastLoginData(data));
        } catch (error) {
          console.error('Login error:', error);
        }
      }
    }),
    updateWebcastMinutesWatched: builder.mutation({
      query: ({ attendanceId }) => ({
        url: '/update-webcast-mins-watched',
        method: 'POST',
        body: { attendanceId }
      })
    }),
    createWebcast: builder.mutation({
      query: (payload) => ({
        url: '/webcast-create',
        method: 'POST',
        body: payload
      })
    })
  })
});

export const {
  useWebcastLogInMutation,
  useCreateWebcastMutation,
  useUpdateWebcastMinutesWatchedMutation
} = webCastApiSlice;
